import { Nullable, Optional } from "../../Common/TypeHelper"

export interface BucketBanner {
  text: Nullable<Optional<string>>
  srcSp: Nullable<Optional<string>>
  srcPc: Nullable<Optional<string>>
  href: Nullable<Optional<string>>
  target: Nullable<Optional<string>>
}

export interface BucketBannerJSON {
  text: Nullable<Optional<string>>
  srcSp: Nullable<Optional<string>>
  srcPc: Nullable<Optional<string>>
  href: Nullable<Optional<string>>
  target: Nullable<Optional<string>>
}

class BucketBannerDTO implements BucketBanner {
  text: Nullable<Optional<string>>
  srcSp: Nullable<Optional<string>>
  srcPc: Nullable<Optional<string>>
  href: Nullable<Optional<string>>
  target: Nullable<Optional<string>>

  constructor(text: Nullable<Optional<string>>,
    srcSp: Nullable<Optional<string>>,
    srcPc: Nullable<Optional<string>>,
    href: Nullable<Optional<string>>,
    target: Nullable<Optional<string>>) {
    this.text = text
    this.srcSp = srcSp
    this.srcPc = srcPc
    this.href = href
    this.target = target
  }

  static fromJSON(jsonObject: BucketBannerJSON): BucketBannerDTO {
    return new BucketBannerDTO(
      jsonObject.text,
      jsonObject.srcSp,
      jsonObject.srcPc,
      jsonObject.href,
      jsonObject.target
    )
  }
}

export default BucketBannerDTO
